import { render } from "./ErrorPage.vue?vue&type=template&id=c6f036ec&scoped=true"
const script = {}

import "./ErrorPage.vue?vue&type=style&index=0&id=c6f036ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c6f036ec"

export default script